document.addEventListener('DOMContentLoaded', function() {
  const mainNav = document.querySelector('.main-nav');
  
  // Identify potential scroll containers
  const potentialScrollContainers = [
    document.querySelector('.main-menu__content'),
    document.querySelector('.main-menu__disclosure'),
    document.querySelector('.main-menu'),
    document.querySelector('store-header')
  ].filter(el => el);

  function getScrollContainer() {
    const scrolled = potentialScrollContainers.find(el => el.scrollTop > 0);
    return scrolled || potentialScrollContainers[0];
  }

  let savedScrollTop = 0;

  // Function to handle menu opening
  function handleMenuOpen(targetElement) {
    const scrollContainer = getScrollContainer();
    
    if (scrollContainer) {
        savedScrollTop = scrollContainer.scrollTop;
        
        // Reset scroll to top
        setTimeout(() => {
            scrollContainer.scrollTop = 0;
        }, 10);
    }

    // Find the submenu container
    const child = targetElement.querySelector('.mega-nav__submenu, .mega-nav__submenu-level-4, .mega-nav__submenu-level-5, .main-nav__child');
    
    if (child) {
       // Force styles
       child.style.minHeight = '100%';
       child.style.height = 'auto';
       
       const style = window.getComputedStyle(child);
       if (style.position === 'absolute' || style.position === 'fixed') {
           child.style.top = '0';
           child.style.left = '0';
           child.style.width = '100%';
           child.style.zIndex = '100';
           child.style.background = 'white';
       }

       // Calculate height and expand parent
       setTimeout(() => {
           const childHeight = child.scrollHeight;
           
           if (mainNav) {
             const minH = Math.max(childHeight, window.innerHeight);
             mainNav.style.minHeight = minH + 'px';
           }
       }, 50);
    }
  }

  function handleMenuClose(targetElement) {
    const scrollContainer = getScrollContainer();
    
    if (mainNav) {
        mainNav.style.minHeight = '';
    }
    
    if (scrollContainer && savedScrollTop > 0) {
        setTimeout(() => {
            scrollContainer.scrollTop = savedScrollTop;
        }, 10);
    }
  }

  // 1. Observe the Top Level Hamburger Menu
  const topLevelDetails = document.querySelector('details.main-menu__disclosure');
  if (topLevelDetails) {
      topLevelDetails.addEventListener('toggle', function(e) {
          if (topLevelDetails.open) {
               const scrollContainer = getScrollContainer();
               if (scrollContainer) scrollContainer.scrollTop = 0;
          }
      });
  }

  // 2. Use Capture Phase for Clicks
  document.addEventListener('click', function(e) {
      const target = e.target;
      // Check for toggle buttons
      const toggleBtn = target.closest('.mega-nav__link, .js-submenu-toggle, .mega-nav__submenu-link-level-4, .mega-nav__submenu-link-level-5, .js-toggle');
      
      if (toggleBtn) {
          setTimeout(() => {
              const parentItem = toggleBtn.closest('.mega-nav__item--toggle, .mega-nav__submenu-item-level-4, .mega-nav__submenu-item-level-5, details');
              
              if (parentItem) {
                  const isActive = parentItem.classList.contains('is-active') || parentItem.hasAttribute('open');
                  
                  if (isActive) {
                      handleMenuOpen(parentItem);
                  } else {
                      handleMenuClose(parentItem);
                  }
              }
          }, 100);
      }
      
      // Handle back buttons
      if (target.closest('.js-back')) {
          handleMenuClose(null);
      }
  }, true); // TRUE = Capture Phase

  // 3. Keep MutationObserver as backup
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        const isNowActive = target.classList.contains('is-active');
        if (isNowActive) {
             handleMenuOpen(target);
        }
      }
    });
  });

  const menuItems = document.querySelectorAll('.mega-nav__item--toggle, .mega-nav__submenu-item, .mega-nav__submenu-item-level-4, .mega-nav__submenu-item-level-5');
  menuItems.forEach(item => {
    observer.observe(item, { 
      attributes: true, 
      attributeFilter: ['class']
    });
  });

});
